module.exports = __webpack_public_path__ + "static/media/wopota.cdcfe8a7.jpg";